import { ArrowUpRight, UsersRound } from 'lucide-react';
import { Link, useParams } from 'react-router-dom';
import { SmartCampusNavigation } from '../../components/landing/SmartCampusNavigation';

const audiences = {
  'private-tutors': { title: 'Private Tutors', description: 'Spend more time helping learners thrive and less time juggling admin, payments and follow-ups.' },
  'schools-academies': { title: 'Schools & Academies', description: 'Give your school one connected place for admissions, learning, fees and daily operations.' },
  'training-centers': { title: 'Training Centers', description: 'Keep every programme, learner and team member moving in the same direction.' },
  'colleges-universities': { title: 'Colleges & Universities', description: 'Coordinate your growing academic community with clarity across every campus function.' },
  'corporate-training': { title: 'Corporate Training', description: 'Deliver exceptional training experiences while keeping enrolment and operations under control.' },
  'education-businesses': { title: 'Education Businesses', description: 'Build a smoother, more connected way for your education team to work together.' },
};

export function AudiencePage() {
  const { audience } = useParams();
  const page = audiences[audience] || { title: 'Built for education teams', description: 'SmartCampus brings every learning business together, whatever shape your teaching takes.' };

  return (
    <main className="platform-page audience-page">
      <SmartCampusNavigation light />
      <section className="platform-placeholder">
        <span><UsersRound size={16} /> Who SmartCampus is for</span>
        <h1>{page.title}</h1>
        <p>{page.description}</p>
        <div><Link to="/register">Get started <ArrowUpRight size={18} /></Link><Link className="platform-placeholder-home" to="/">Back to home</Link></div>
      </section>
    </main>
  );
}
